const noResultData = {
  title: 'Sorry, we can’t find what you’re looking for.',
  description:
    'Try making your search simpler, double-check your spelling, or clear your filters and try again.',
  buttonLabel: 'Browse all fonts',
  href: '/fonts',
};

export default noResultData;
